import type ExploreServiceFilters from '@alltrails/explore-service/types/ExploreServiceFilters';
import type { LegacyFilters } from '../types/LegacyFilters';

/**
 * Convert legacy filters (from PersonalizationService) to explore-service format
 * Handles snake_case to camelCase conversion and format transformations
 * @param legacyFilters - Legacy filter format from PersonalizationService.create_filters_json
 * @returns Explore-service filter format
 */
export const convertLegacyFiltersToExploreService = (legacyFilters: LegacyFilters): ExploreServiceFilters => {
  const exploreFilters: ExploreServiceFilters = {};

  // Convert rating to minRating (parse string to number if needed)
  if (legacyFilters.rating !== undefined && legacyFilters.rating !== null) {
    exploreFilters.minRating = typeof legacyFilters.rating === 'string' ? parseFloat(legacyFilters.rating) : legacyFilters.rating;
  }

  // Convert elevation_gain (snake_case) to elevationGain (camelCase)
  if (legacyFilters.elevation_gain) {
    exploreFilters.elevationGain = {
      min: legacyFilters.elevation_gain.min,
      max: legacyFilters.elevation_gain.max
    };
  }

  // Length is already in the correct format (min/max object)
  if (legacyFilters.length) {
    exploreFilters.length = {
      min: legacyFilters.length.min,
      max: legacyFilters.length.max
    };
  }

  // Arrays that just need to be passed through
  if (legacyFilters.difficulty?.length) {
    exploreFilters.difficulty = legacyFilters.difficulty as any;
  }

  if (legacyFilters.activity?.length) {
    exploreFilters.activity = legacyFilters.activity as any;
  }

  if (legacyFilters.feature?.length) {
    exploreFilters.feature = legacyFilters.feature as any;
  }

  if (legacyFilters.suitability?.length) {
    exploreFilters.suitability = legacyFilters.suitability as any;
  }

  // Convert route_type to routeType
  if (legacyFilters.route_type?.length) {
    exploreFilters.routeType = legacyFilters.route_type as any;
  }

  // Convert trail_traffic to trailTraffic
  if (legacyFilters.trail_traffic?.length) {
    exploreFilters.trailTraffic = legacyFilters.trail_traffic as any;
  }

  // Note: trail_completion is not supported in ExploreServiceFilters TypeScript type
  // The Ruby contract supports trailCompletion, but it's not in the TS type definition
  // If needed, trail completion filtering should be handled via recordIds instead

  // Convert is_closed to isClosed
  // Only include isClosed when it's true (omit when false)
  if (legacyFilters.is_closed === true) {
    exploreFilters.isClosed = true;
  }

  // Note: is_private_property is not supported in explore-service, so we skip it

  return exploreFilters;
};

